import { environment } from './environment';
import { IEnvironment } from './interfaces';
import { sessionStorageSupported } from '@app/lib/utils';

export const getEnvironmentValues = (): IEnvironment => {

  let environmentSessionString;

  if (sessionStorageSupported) {
    environmentSessionString = sessionStorage.getItem('environment') as string || '{{';
  }

  const values: IEnvironment = environmentSessionString.startsWith('{{') ? environment : JSON.parse(environmentSessionString);

  return values;
};
